export default "__VITE_ASSET__C$WtLtcp__"